import { STAGE_META, stageTone } from "@/lib/enrollmentTypes";

export default function StageBadge({ stage, size = "sm" }) {
  const meta = STAGE_META[stage];
  const tone = stageTone(stage);
  if (!meta) return null;
  const Icon = meta.icon;
  const pad = size === "xs" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={`stage-badge-${stage}`}
      className={`inline-flex items-center gap-1.5 rounded-full border ${tone.ring} ${tone.bg} ${tone.color} ${pad} font-semibold uppercase tracking-wider`}
    >
      <Icon size={12} weight="duotone" aria-hidden />
      {meta.short}
    </span>
  );
}
